import React from "react";
import Note from "../../Assets/images/note.svg";

function ActiveFinancedTransactionsTab({
  loadingTransactions,
  transactions,
  formatAmount,
  amountFinanced,
  dateFinanced,
}) {
  return (
    <div>
      {loadingTransactions ? (
        <div className="flex justify-center my-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#00BC67]"></div>
        </div>
      ) : transactions.length > 0 ? (
        <div className="space-y-3">
          {transactions.map((tx, idx) => (
            <div
              key={tx.id || idx}
              className="bg-white rounded-[16px] border border-[#F1F5F9] p-4 shadow-2xs flex items-center justify-between"
            >
              <div>
                <p className="text-[#1E222B] text-[13px] font-[700]">
                  {tx.description || tx.transactionType || "Unit Purchase"}
                </p>
                <p className="text-[#808285] text-[11px] font-[400] mt-0.5">
                  {tx.date || tx.createdAt
                    ? new Date(tx.date || tx.createdAt).toLocaleDateString()
                    : dateFinanced}
                </p>
              </div>
              <p className="text-[#1E222B] text-[14px] font-[700]">
                ₦{formatAmount(tx.amount || amountFinanced)}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <div className="bg-white rounded-[16px] border border-dashed border-gray-200 p-8 text-center flex flex-col items-center justify-center my-4">
          <img
            src={Note}
            alt="No transactions"
            className="w-14 h-14 opacity-50 mb-3"
          />
          <h4 className="text-[#1E222B] font-[700] text-[14px] mb-1">
            No Transactions Yet
          </h4>
          <p className="text-[#808285] text-[12px] max-w-xs leading-relaxed">
            Your financing transactions and payment history for this listing
            will appear here.
          </p>
        </div>
      )}
    </div>
  );
}

export default ActiveFinancedTransactionsTab;
